module.exports = __webpack_public_path__ + "static/media/pay_shop.57a8226e.svg";